module.exports = __webpack_public_path__ + "img/1-colect.2c203c4d.gif";